(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as P, useQuery as re, useLazyQuery as Ie, useMutation as $, isApolloError as Pe } from "@apollo/client";
import { getOperationName as V } from "@apollo/client/utilities";
import { jsx as i, jsxs as h, Fragment as k } from "react/jsx-runtime";
import { FormField as B, FieldWrapper as I, Badge as J, Icon as Y, FlexBox as b, Text as D, List as oe, Banner as se, Button as _, Modal as xe, ModalHead as We, ModalBody as ke, ModalFoot as _e, Spinner as Z, Tag as Le, Tooltip as ae, FieldSwitch as Re, InputSelectionList as $e, SelectionList as Be } from "@dixa/lib-shared-habla";
import { Link as Fe } from "react-router-dom";
import { colors as v } from "@dixa/lib-shared-tokens";
import { useState as m, useEffect as M, createContext as ce, useContext as de, createElement as H, useCallback as K } from "react";
import { FormProvider as Ge } from "react-hook-form";
import le from "moment";
import { useInterval as Ue } from "react-use";
import He from "lodash/lowerCase";
import Ke from "lodash/upperFirst";
import { HookFormText as Ve } from "lib-shared-hook-form";
import { MockedProvider as ze } from "@apollo/client/testing";
import { render as Qe } from "@testing-library/react";
const ue = P`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, ge = P`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
    $renderConditions: [Management_JSONObject!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, me = P`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
    $renderConditions: [Management_JSONObject!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, fe = P`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, Kt = (e, t) => function(n, o) {
  return re(n, {
    ...o,
    context: {
      operationName: V(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Vt = (e, t) => function(n, o) {
  return Ie(n, {
    ...o,
    context: {
      operationName: V(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, zt = (e, t, n) => function(o, r) {
  return n.query({
    query: o,
    variables: r,
    context: {
      operationName: V(o),
      widgetId: e,
      widgetType: t
    }
  });
}, Qt = (e, t) => function(n, o) {
  return $(n, {
    ...o,
    context: {
      operationName: V(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, qt = ({
  getValueByKey: e
}) => {
  const t = e("dixaApiTokenId")?.value, n = e("dixaApiTokenName")?.value;
  return /* @__PURE__ */ i(B, { children: /* @__PURE__ */ i(I, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ i(k, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ h(k, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ i(J, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ i(Fe, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, qe = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", Jt = ({
  errors: e
}) => e.some((t) => qe({ error: t })), Je = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", Yt = ({
  errors: e
}) => e.some((t) => Je({ error: t })), Ye = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", Zt = ({
  errors: e
}) => e.some((t) => Ye({ error: t })), Ze = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", jt = ({
  errors: e
}) => e.some((t) => Ze({ error: t })), je = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", Xt = ({
  errors: e
}) => e.some((t) => je({ error: t })), Xe = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", en = ({
  errors: e
}) => e.some((t) => Xe({ error: t })), et = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", tn = ({
  errors: e
}) => e.some((t) => et({ error: t })), tt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", nn = ({
  errors: e
}) => e.some((t) => tt({ error: t })), nt = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", on = ({
  errors: e
}) => e.some((t) => nt({ error: t })), ot = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", it = ({
  errors: e
}) => e.some((t) => ot({ error: t })), rt = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = m(!1);
  return M(() => {
    const s = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(s);
  }, [t, n]), { isCopied: n, copy: (s) => {
    navigator.clipboard.writeText(s), o(!0);
  } };
}, st = "_errorWrapper_171rr_1", at = "_copyIcon_171rr_5", q = {
  errorWrapper: st,
  copyIcon: at
}, he = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1,
  hideCopyButton: o = !1
}) => {
  const s = e && Pe(e) && e?.graphQLErrors?.length > 0, { isCopied: a, copy: l } = rt(), g = /* @__PURE__ */ i(
    Y,
    {
      color: v.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || s && it({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ h(b, { margin: "0 0 100", padding: "200", className: q.errorWrapper, children: [
      /* @__PURE__ */ i(b, { margin: "0 300 0 0", alignItems: "center", children: g }),
      /* @__PURE__ */ i(D.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!s)
    return /* @__PURE__ */ i(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ i(
      oe.Item,
      {
        contentLeft: g,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const p = e?.graphQLErrors || [];
  return /* @__PURE__ */ h(
    b,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: q.errorWrapper,
      children: [
        p.map((d, f) => {
          const u = d?.extensions?.integration, C = u?.message || e?.message || "No error message available", y = u?.responseBody && JSON.parse(u?.responseBody), w = y?.errorMessages || [], A = y?.warningMessages || [], c = [...w, ...A].join(" ");
          return /* @__PURE__ */ i(
            oe.Item,
            {
              title: C,
              titleSecondary: c,
              contentLeft: g
            },
            f
          );
        }),
        !o && /* @__PURE__ */ h(b, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ i(
            se,
            {
              variant: "info",
              description: /* @__PURE__ */ i(D.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ h(b, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ i(_, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ i(
              _,
              {
                variant: "secondary",
                icon: a ? "done" : "copy",
                onClick: () => l(JSON.stringify(p, null, 2)),
                className: q.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, ct = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: r,
  confirmLabel: s,
  cancelLabel: a = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: g = "secondary",
  isOpen: p,
  setIsOpen: d,
  showOnClose: f = !1
}) => /* @__PURE__ */ h(
  xe,
  {
    isOpen: p,
    onClose: () => {
      r && r(), d(!1);
    },
    children: [
      /* @__PURE__ */ i(
        We,
        {
          title: e,
          onClose: f ? r : void 0
        }
      ),
      /* @__PURE__ */ h(ke, { children: [
        t && /* @__PURE__ */ i("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ i(
        _e,
        {
          confirmOnClick: o ? () => {
            o(), d(!1);
          } : void 0,
          cancelOnClick: () => {
            r && r(), d(!1);
          },
          confirmName: s,
          cancelName: a,
          confirmProps: { variant: l },
          cancelProps: { variant: g }
        }
      )
    ]
  }
), j = "The configuration of the integration is not correct. Please check the settings.", rn = ({
  cause: e
}) => /* @__PURE__ */ i(b, { margin: "0 0 400", children: /* @__PURE__ */ i(
  se,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ h(b, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ i(D.Paragraph, { children: e || j }),
      /* @__PURE__ */ h(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ i(D.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ i(D.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), sn = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: r,
  isLoading: s,
  isWidgetUnknown: a,
  children: l
}) => o ? /* @__PURE__ */ i(he, { error: o, retry: r }) : s ? /* @__PURE__ */ i(Z, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ h(D.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ i(Le, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ i(Ge, { ...e, children: /* @__PURE__ */ i(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: l
  }
) });
function an(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const cn = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, dn = (e) => {
  const t = He(e);
  return t.length === 0 ? e : Ke(t);
}, pe = "DD MMM YYYY @ HH:mm";
function dt(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function lt(e, t) {
  return e == null ? t : String(e);
}
function ln(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const un = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], gn = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (s) => e.startsWith(s)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && r)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (r)
    return r;
};
function ut(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const Ce = ce(null);
function gt() {
  const e = de(Ce);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function mt() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
const ye = ce(null), ft = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ye.Provider
);
function we() {
  const e = de(ye);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
function mn() {
  window._partner = {
    events: { emit: () => {
    } }
  };
}
const ht = {
  useMutation: $,
  useQuery: () => {
  },
  useLazyQuery: () => {
  },
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, pt = {
  baseUrl: "http://localhost/graphql"
};
function fn(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), r = vi.fn(), a = { ...{
    configuration: pt,
    handleRedirect: o,
    showNotification: r
  }, ...n };
  return { ...Qe(
    H(
      ze,
      { mocks: t },
      H(
        Ce.Provider,
        { value: mt() },
        H(
          ft,
          { value: ht },
          H(e, a)
        )
      )
    )
  ), handleRedirect: o, showNotification: r };
}
function hn({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: ue,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              renderConditions: t?.renderConditions ?? [],
              settings: n
            }
          ]
        }
      }
    }
  };
}
function pn({
  variables: e,
  result: t
}) {
  const n = {
    ...e,
    renderConditions: e.renderConditions ?? []
  };
  return {
    request: {
      query: me,
      variables: n
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? n.renderConditions,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function Cn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: ge,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            renderConditions: t?.renderConditions ?? e.renderConditions ?? [],
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function yn({
  id: e
}) {
  return {
    request: {
      query: fe,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function Ct(e, t) {
  const n = {};
  for (const o of t) {
    const s = e.find((a) => a.key === o.key)?.value;
    o.secret && s === void 0 || (o.type === "boolean" ? n[o.key] = dt(s, o.defaultValue) : n[o.key] = lt(s, o.defaultValue));
  }
  return n;
}
function yt(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
async function wn(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: r,
  renderConditions: s
}) {
  const a = yt(e, t), l = {
    name: e.name,
    enabled: e.enabled,
    settings: a,
    ...s !== void 0 && { renderConditions: s }
  };
  n ? await o(l) : await r(l);
}
function wt(e) {
  const { user_id: t, iss: n } = ut(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function Et(e) {
  return e.startsWith("http://localhost");
}
function X() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const At = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: v.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: v.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: v.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: v.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: v.neutral[500],
        tooltip: "Not connected"
      };
  }
}, En = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [r, s] = m("CONNECTING"), [a, l] = m(""), [g, p] = m(null), { track: d } = X(), { icon: f, color: u, tooltip: C } = At(r), y = 3, w = 15, A = 2e3, [c, N] = m({}), [S, x] = m(0), [W, F] = m(A), [T, z] = m(!1), [Ee, Ae] = m(y), {
    isInboundOAuth: be,
    setIsInboundOAuth: Ne,
    hasTriggeredAuthorization: Se,
    setHasTriggeredAuthorization: Me
  } = gt(), { baseUrl: G } = e, De = `${G}/auth/connect/${n.toLowerCase()}/${t}`, Te = `${G}/auth/status/${n.toLowerCase()}/${t}`, ee = r === "CONNECTING", te = (E) => Object.keys(E).length === 0, Q = () => {
    z(!1), x(0);
  };
  M(() => {
    const E = localStorage.getItem("authData");
    if (E) {
      const O = JSON.parse(E ?? "{}").access_token;
      N({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${O}`,
          ...Et(G) && wt(O)
        }
      });
    }
  }, [G]), M(() => {
    te(c) || z(!0);
  }, [c]);
  const Oe = () => {
    Ae(w), fetch(Te, { ...c }).then((E) => E.json()).then(({ data: E }) => {
      const { status: L, createdAt: O, createdByName: R } = E;
      switch (L) {
        case "CONNECTING":
          s("CONNECTING");
          break;
        case "CONNECTED": {
          if (d("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), s("CONNECTED"), O && R) {
            const U = new Date(O);
            isNaN(U.getTime()) || p(U), l(R);
          }
          Q();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          s(L), Q();
      }
    }).catch((E) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        E
      ), s("CONNECTION_FAILED");
    });
  };
  Ue(
    () => {
      S >= Ee ? (s("CONNECTION_TIMEOUT"), Q()) : (Oe(), x(S + 1));
    },
    T ? W : null
  );
  const ne = () => {
    d("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(De, { ...c }).then((E) => E.json()).then(({ data: E }) => {
      const { url: L } = E, O = 620, R = 800, U = window.innerWidth / 2 - O / 2, ve = window.innerHeight / 2 - R / 2;
      s("CONNECTING"), z(!0), window.open(
        L,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${O},
						height=${R},
						left=${U},
						top=${ve}`
      );
    }).catch((E) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        E
      ), s("CONNECTION_FAILED");
    });
  };
  return M(() => {
    be && !Se && !te(c) && (Me(!0), Ne(!1), ne());
  }, [c]), /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ i(B, { span: 3, children: /* @__PURE__ */ i(
      I,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ h(b, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ i(
            _,
            {
              icon: "key",
              variant: "secondary",
              onClick: ne,
              disabled: ee,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ i(ae, { content: C, children: ee ? /* @__PURE__ */ i(Z, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ h(b, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ i(
              Y,
              {
                "data-testid": "oauth-button-status-icon",
                name: f,
                color: u
              }
            ),
            r === "CONNECTED" && a && g && /* @__PURE__ */ h(D.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              le(g).format(pe)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ i(B, { span: 3 })
  ] });
}, bt = "_settingsWrapper_eleyu_1", Nt = {
  settingsWrapper: bt
}, St = P`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, ie = [], An = ({
  settings: e,
  getValueByKey: t,
  handleChangeSelect: n
}) => {
  const o = "subscriptionListId", s = e?.find(
    (c) => c.key === o
  )?.label ?? "Activate re-/subscription list selection", a = t(o)?.value, { useQuery: l } = we(), [g, p] = m(ie), [d, f] = m(!!a), [u, C] = m(a), {
    data: y,
    error: w,
    loading: A
  } = l(St, {
    skip: !d,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return M(() => {
    a && (C(a), f(!0));
  }, [a]), M(() => {
    const c = y?.Klaviyo?.get_lists;
    if (d && c && !A && !w) {
      const N = c?.data?.map(
        (S) => ({
          value: S?.id,
          label: S?.attributes?.name
        })
      ) || ie;
      p(N);
    }
  }, [d, y, A, w]), /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ i(B, { span: 3, children: /* @__PURE__ */ h(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: Nt.settingsWrapper,
        children: [
          /* @__PURE__ */ i(I, { label: s, children: /* @__PURE__ */ i(
            Re,
            {
              input: {
                name: `${o}-switch`,
                value: "switchValueFromComponent",
                checked: d,
                onChange: () => {
                  const c = !d;
                  c || n(o, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), f(c);
                }
              }
            }
          ) }),
          d && w && !A && /* @__PURE__ */ i(I, { children: /* @__PURE__ */ i(he, { error: w }) }),
          d && !w && A && /* @__PURE__ */ i(I, { children: /* @__PURE__ */ i(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ i(Z, {}) }) }),
          d && !w && !A && g && /* @__PURE__ */ i(I, { label: "Available lists to subscribe to", children: /* @__PURE__ */ i(
            $e,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (c) => {
                n(o, c), C(c?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (c) => c ? /* @__PURE__ */ i(D.Paragraph, { children: c.label }) : null,
              value: u ? [
                {
                  label: (g || []).find(
                    (c) => c.value === u
                  )?.label,
                  value: u
                }
              ] : [],
              equalityFn: (c, N) => c.value === N.value,
              children: g.map((c) => /* @__PURE__ */ i(Be.Item, { value: c, children: c.label }, c.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ i(B, { span: 3 })
  ] });
}, bn = (e) => {
  if (e == null)
    return null;
  if (Array.isArray(e))
    return /* @__PURE__ */ i(D.Paragraph, { variant: "5", color: "secondary", align: "right", children: e.join(", ") });
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ i(
      Y,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? v.green[500] : v.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ i(J, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), r = o.startsWith("-"), s = o === "0", a = r ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ i(D.Paragraph, { variant: "5", color: "secondary", children: s ? "today" : a });
  }
  const n = le(e);
  return n.isValid() ? /* @__PURE__ */ i(D.Paragraph, { variant: "5", color: "secondary", children: n.format(pe) }) : /* @__PURE__ */ i(J, { variant: "info", size: "small", children: e });
}, Nn = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: r } = e, [s, a] = m(t);
  if (!s) {
    const l = typeof n == "string" ? n : "";
    return /* @__PURE__ */ i(I, { label: n, helpIcon: o, children: /* @__PURE__ */ h(
      _,
      {
        "data-testid": `secret-field-button-${r}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          l
        ]
      }
    ) });
  }
  return /* @__PURE__ */ i(
    Mt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, Mt = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, r = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ i(
    Ve,
    {
      ...e,
      componentProps: r,
      shouldUnregister: !0
    }
  );
}, Dt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, Sn = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: r,
  automationCouplingState: s,
  onConfirmDelete: a,
  labels: l,
  deleteConfirmationBody: g,
  confirmDeleteVariant: p = "primary"
}) => {
  const { track: d } = X(), [f, u] = m(!1), C = { ...Dt, ...l }, y = !s || !s.isCoupled, w = () => {
    t && d("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), u(!0);
  }, A = () => {
    t && d("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ h(k, { children: [
    /* @__PURE__ */ h(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ i(_, { type: "submit", isLoading: r, disabled: r, children: C.submit }),
      !o && /* @__PURE__ */ i(
        ae,
        {
          content: "The widget is used in automations",
          disabled: y,
          children: /* @__PURE__ */ i(
            _,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: w,
              disabled: !y,
              isLoading: s?.isLoading,
              children: C.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ i(
      ct,
      {
        isOpen: f,
        setIsOpen: u,
        confirmVariant: p,
        confirmLabel: C.confirmDelete,
        cancelLabel: C.cancelDelete,
        onCancel: A,
        onConfirm: a,
        children: /* @__PURE__ */ i(b, { children: g ?? /* @__PURE__ */ h(k, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, Tt = P`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Ot = P`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Mn(e) {
  const { useQuery: t, useMutation: n } = we(), [o, r] = m(), [s, a] = m(), [l, g] = m(!1), {
    loading: p,
    data: d,
    error: f
  } = t(
    Tt,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [u, { loading: C, error: y }] = n(
    Ot
  ), w = async (A, c) => await u({
    variables: {
      conversationId: (c ?? e)?.toString(),
      data: A
    }
  }).then(
    ({ data: S }) => r(S?.Storage?.storeWidgetData?.data ?? {})
  );
  return M(() => {
    !p && d && r(d?.Storage?.widgetData ?? {});
  }, [d, p]), M(() => f && a(f), [f]), M(() => g(p), [p]), M(() => y && a(y), [y]), M(() => g(C), [C]), {
    data: o,
    loading: l,
    store: w,
    error: s
  };
}
const Dn = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: r } = X(), [s, a] = m(!1), [l, g] = m(), [p, d] = m(null), f = K(
    (N) => (S) => {
      g(S), a(!1), o({
        title: "Something went wrong",
        text: `The ${N} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [u] = $(me, {
    onError: f("creation")
  }), [C] = $(ge, {
    onError: f("update")
  }), [y] = $(fe, {
    onError: f("deletion")
  }), w = K(
    async ({
      name: N,
      enabled: S,
      settings: x,
      renderConditions: W = []
    }) => {
      r("settings:create:submitted", { widgetType: t }), a(!0), g(void 0);
      const { data: F } = await u({
        variables: {
          type: t,
          name: N,
          enabled: S,
          settings: x,
          renderConditions: W
        }
      });
      a(!1);
      const T = F?.Management?.createWidgetConfiguration;
      if (!T) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(T.id);
    },
    [u, n, t, o, r]
  ), A = K(
    async ({
      name: N,
      enabled: S,
      settings: x,
      renderConditions: W
    }) => {
      if (!e)
        return;
      r("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      }), a(!0), g(void 0);
      const { data: F } = await C({
        variables: {
          id: e,
          name: N,
          enabled: S,
          settings: x,
          ...W !== void 0 && { renderConditions: W }
        }
      });
      a(!1);
      const T = F?.Management?.updateWidgetConfiguration;
      if (!T) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      T.misconfigured ? d(
        T.misconfigurationCause ?? j
      ) : d(null), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [e, t, o, r, C]
  ), c = K(async () => {
    if (!e)
      return;
    r("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), g(void 0);
    const { data: N } = await y({
      variables: { id: e }
    });
    a(!1), N?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    y,
    n,
    e,
    t,
    o,
    r
  ]);
  return {
    create: w,
    update: A,
    remove: c,
    isLoading: s,
    error: l,
    misconfigurationCause: p,
    setMisconfigurationCause: d
  };
};
function Tn({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [r, s] = m(!1), [a, l] = m(), { loading: g, error: p, refetch: d } = re(ue, {
    variables: { id: e },
    skip: !e,
    onCompleted: (f) => {
      const u = f?.Management?.widgetConfigurations?.[0];
      if (!u) {
        s(!0), l(void 0);
        return;
      }
      s(!1), l(u), n.reset({
        ...Ct(u.settings ?? [], t),
        enabled: !!u.enabled,
        name: u.name
      }), u.misconfigured && o?.(
        u.misconfigurationCause ?? j
      );
    }
  });
  return M(() => {
    s(!1), l(void 0);
  }, [e]), {
    isLoading: g,
    error: p,
    isWidgetUnknown: r,
    refetch: d,
    widgetConfiguration: a
  };
}
export {
  he as DisplayErrors,
  qt as DixaApiTokenSettings,
  Ce as InboundOAuthContext,
  ct as IntegrationModal,
  An as KlaviyoSubscribeSetting,
  rn as MisconfigurationBanner,
  En as OAuthSettings,
  Nn as PartnerHookFormSecretText,
  sn as PartnerSettingsWrapper,
  ft as WidgetContextProvider,
  Sn as WidgetSettingsFormFooter,
  cn as capitalizeFirstCharacter,
  un as countryCodes,
  mt as createMockInboundOAuthContextOptions,
  pn as createWidgetConfigurationCreateMock,
  yn as createWidgetConfigurationDeleteMock,
  me as createWidgetConfigurationMutation,
  hn as createWidgetConfigurationQueryMock,
  Cn as createWidgetConfigurationUpdateMock,
  an as deepClone,
  pe as defaultDateFormat,
  j as defaultMisconfigurationCause,
  pt as defaultPartnerSettingsConfiguration,
  ht as defaultWidgetContextValue,
  fe as deleteWidgetConfigurationMutation,
  bn as displayAttributeValue,
  yt as formValuesToSettings,
  At as getConnectionStatusValues,
  ln as getCountryNameFromCountryCode,
  St as getListsQuery,
  wt as getPartnerDevApiHeaders,
  ue as getWidgetConfigurationByIdQuery,
  wn as handleWidgetSubmit,
  Jt as hasDixaHeaderCheckError,
  Yt as hasDownstreamApiAuthorizationError,
  tn as hasDownstreamApiBadRequestError,
  en as hasDownstreamApiConflictError,
  nn as hasDownstreamApiForbiddenError,
  Xt as hasDownstreamApiNotFoundError,
  Zt as hasDownstreamApiPermissionError,
  jt as hasDownstreamApiServiceUnavailableError,
  on as hasDownstreamApiTooManyRequestsError,
  it as hasWidgetMisconfiguredError,
  dn as humanizeKey,
  qe as isDixaHeaderCheckError,
  Je as isDownstreamApiAuthorizationError,
  et as isDownstreamApiBadRequestError,
  Xe as isDownstreamApiConflictError,
  tt as isDownstreamApiForbiddenError,
  je as isDownstreamApiNotFoundError,
  Ye as isDownstreamApiPermissionError,
  Ze as isDownstreamApiServiceUnavailableError,
  nt as isDownstreamApiTooManyRequestsError,
  Et as isRunningLocalPartnerApi,
  ot as isWidgetMisconfiguredError,
  zt as makeExecuteQuery,
  Vt as makeUseLazyQuery,
  Qt as makeUseMutation,
  Kt as makeUseQuery,
  ut as parseAccessToken,
  dt as parseBoolean,
  lt as parseString,
  fn as renderPartnerSettings,
  Ct as settingsToFormValues,
  mn as stubPartnerEventsBusForTests,
  ge as updateWidgetConfigurationMutation,
  rt as useCopyWithDelay,
  Mn as useData,
  gt as useInboundOAuthContext,
  X as useTracking,
  we as useWidgetContext,
  Dn as useWidgetSettingsMutations,
  Tn as useWidgetSettingsQuery,
  gn as validateApiHostName
};
